//
//
//
//
//
//
//

export default {
  props: {
    iconType: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      iconClass: ['icon-loading1', 'icon-loading2']
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/g-button/index.vue